/**
 * Field Favorites API utilities.
 *
 * Free-text field favorites (awards, exhibitions, publications, locations).
 * Mirrors the Getty favorites pattern but stores plain strings instead of
 * URI/breadcrumb tuples.
 */

import api from './api';

export type FieldFavoriteType = 'awards' | 'exhibitions' | 'publications' | 'locations' | 'provenance';

export interface FieldFavoritesResponse {
  awards: string[];
  exhibitions: string[];
  publications: string[];
  locations: string[];
  provenance: string[];
  updatedAt: string | null;
}

export const getFieldFavorites = async (ownerId?: string): Promise<FieldFavoritesResponse> => {
  const params: Record<string, string> = {};
  if (ownerId) {
    params.owner_id = ownerId;
  }
  const response = await api.get('/api/field-favorites', { params });
  return response.data;
};

export const addFieldFavorite = async (
  favoriteType: FieldFavoriteType,
  value: string,
  ownerId?: string
): Promise<FieldFavoritesResponse> => {
  const response = await api.post(
    '/api/field-favorites',
    { favoriteType, value },
    ownerId ? { params: { owner_id: ownerId } } : undefined
  );
  return response.data;
};

export const removeFieldFavorite = async (
  favoriteType: FieldFavoriteType,
  value: string,
  ownerId?: string
): Promise<FieldFavoritesResponse> => {
  const params: Record<string, string> = { favorite_type: favoriteType, value };
  if (ownerId) {
    params.owner_id = ownerId;
  }
  const response = await api.delete('/api/field-favorites', { params });
  return response.data;
};
